import React from 'react';
import { Chart as ChartJs } from 'primereact/chart';
import { ChartProps } from './Chart.types';
import { TooltipItem } from 'chart.js';

const Chart: React.FC<ChartProps> = ({ labels, data, type, stepSize }) => {
  const dataChart = {
    labels,
    datasets: [
      {
        backgroundColor: '#FEC200',
        borderColor: '#FEC200',
        data: data,
        maxBarThickness: 52,
        minBarLength: 5,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#1D1D1D',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: {
          x: 20,
          y: 15,
        },
        bodyAlign: 'center' as const,
        titleAlign: 'center' as const,
        displayColors: false,
        callbacks: {
          title: (tooltipItems: TooltipItem<'bar'>[]) => {
            return tooltipItems[0].formattedValue;
          },
          label: (tooltipItem: TooltipItem<'bar'>) => {
            return tooltipItem.label;
          },
        },
        bodyFont: {
          size: 14,
        },
        usePointStyle: false,
        boxWidth: 59,
        boxHeight: 27,
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#ADADB1',
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: '#ADADB1',
          stepSize: stepSize,
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="p-4 bg-black text-white">
      <div className="w-full">
        <ChartJs type={type} data={dataChart} options={options} />
      </div>
    </div>
  );
};

export default Chart;
